<template>
  <RequestedOfferCardContainer
    v-bind="$attrs"
    :offer="offer"
    product-label="Veículo em garantia"
  />
</template>
<script>
import RequestedOfferCardContainer from '@/containers/loans/RequestedOfferCardContainer.vue'
export default {
  name: 'AutoRequestedOfferCardContainer',
  components: {
    RequestedOfferCardContainer,
  },
  props: {
    offer: { type: Object, required: true },
  },
}
</script>
<style lang="scss"></style>
